module.exports = __webpack_public_path__ + "static/media/image-2.52eeb124.webp";